// TODO: this upload form only works against v1 api, non multi-qa.
import {
  Checkbox,
  createMuiTheme,
  FormControl,
  FormControlLabel,
  IconButton,
  MuiThemeProvider,
  TextField
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { css } from "emotion";
import debounce from "lodash/debounce";
import moment from "moment";
import { filter, join, map } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import AsyncSelect from "react-select/lib/Async";
import { OptionProps } from "react-select/lib/components/Option";
import api from "src/api";
import { addComment, AddCommentActionType } from "src/commentView/actions";
import { CommentPopover } from "src/commentView/CommentPopover";
import { DEBOUNCE_DELAY } from "src/constants";
import { toTitleCase } from "src/helpers";
import { getUserId } from "src/login/selector";
import { isMetaDataValueAModelTemplate } from "src/metadata/helpers";
import { dateFormat, getMetadataUploadFormConfig } from "src/metadata/selector";
import QuiqButton from "src/shared/QuiqButton";
import TextInput from "src/shared/TextInput";
import { Key } from "ts-keycode-enum";
import colors from "../../colors.scss";
import { AddCommentIcon } from "../../commentView/AddCommentIcon";
import { CommentIcon } from "../../commentView/CommentIcon";
import { Comment } from "../../commentView/types";
import {
  reloadBriefSpreads,
  ReloadBriefSpreadsActionType
} from "../../documentList/actions";
import {
  MetadataFormState,
  MetadataId,
  MetadataInput,
  MetadataInputOption,
  MetadataItemsContainingIds
} from "../../metadata/types";
import DateInput from "../../shared/DateInput";
import { State } from "../../state";
import {
  onUploadFormChange,
  uploadFinancialDocument,
  UploadFinancialDocumentActionType
} from "../actions";
import { formatEntityValue, transformSearchEntityResults } from "../helpers";
import { DocumentUploadFormState, STATES } from "../reducer";
import { Entity, EntityDropdownOption, Period } from "../types";
import "./DocumentUploadForm.scss";

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      main: colors.moodysBlue || "#009bdf"
    }
  },
  typography: {
    useNextVariants: true
  }
});

interface DocumentUploadFormProps {
  uploadFinancialDocument: UploadFinancialDocumentActionType;
  onUploadFormChange: typeof onUploadFormChange;
  form: DocumentUploadFormState;
  requestStatus: STATES;
  errorMessage: string;
  closeModal: () => void;
  reloadBriefSpreads: ReloadBriefSpreadsActionType;
  toggleCreateEntityModal: () => void;
  userId: string;
  addComment: AddCommentActionType;
  metadataUploadFormConfig: MetadataInput[] | null;
  dateFormat?: string | any;
}

interface DocumentUploadFormComponentState {
  fileInputKey: number;
  showDateInputError: boolean;
  priority: boolean;
  entity: Entity | null;
  isDragAndDropActive: boolean;
  entityInputValue: string;
  entitySearchResults: EntityDropdownOption[];
  showEntityDropdownError: boolean;
  showFileError: boolean;
  commentPopoverAnchorElPeriod1: HTMLElement | null;
  commentPopoverAnchorElPeriod2: HTMLElement | null;
  commentsPeriod1: Comment[];
  commentsPeriod2: Comment[];
  metadataFormState: MetadataFormState | any;
  metadataIds: MetadataId[];
}

export class DocumentUploadForm extends React.Component<
  DocumentUploadFormProps,
  DocumentUploadFormComponentState
> {
  private entityKeyCode: number | undefined;

  constructor(props: DocumentUploadFormProps) {
    super(props);
    this.state = {
      fileInputKey: 1,
      showDateInputError: false,
      priority: false,
      entity: null,
      isDragAndDropActive: false,
      entityInputValue: "",
      entitySearchResults: [],
      showEntityDropdownError: false,
      showFileError: false,
      commentPopoverAnchorElPeriod1: null,
      commentPopoverAnchorElPeriod2: null,
      commentsPeriod1: [],
      commentsPeriod2: [],
      metadataFormState: {},
      metadataIds: []
    };
  }

  public componentWillMount() {
    this.fetchNewEntities = debounce(this.fetchNewEntities, DEBOUNCE_DELAY);
    this.initMetadataFormState();

    if (!this.props.metadataUploadFormConfig) {
      return;
    }

    this.props.metadataUploadFormConfig.map(configField => {
      if (configField.defaultValue) {
        this.props.onUploadFormChange({
          [configField.formKey]: configField.defaultValue.value
        });
      }
    });
  }

  public componentWillReceiveProps(nextProps: DocumentUploadFormProps) {
    if (nextProps.requestStatus === STATES.SUCCESS) {
      this.setState({
        fileInputKey: this.state.fileInputKey + 1
      });
      this.props.reloadBriefSpreads();
      this.props.closeModal();
    }
  }

  public handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.props.onUploadFormChange({ file: files[0] });
    this.setState({ showFileError: false });
  };

  public handleEntityChange = (option: EntityDropdownOption) => {
    if (option) {
      this.props.onUploadFormChange({ entity: option });
      this.setState({ showEntityDropdownError: false });
    }
  };

  public handleEntityInputChange = (newValue: string) => {
    if (!newValue && this.entityKeyCode !== Key.Backspace) {
      return;
    }

    this.setState(() => ({
      entityInputValue: newValue
    }));
  };

  public handleEntityKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    this.entityKeyCode = event.keyCode;
  };

  public handlePriorityChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.props.onUploadFormChange({
      [event.target.name]: event.target.checked
    });
  };

  public handleChangePeriod = (event: React.ChangeEvent<{}>, value: string) => {
    this.props.onUploadFormChange({ numPeriods: parseInt(value, 10) });
  };

  public handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { form, metadataUploadFormConfig } = this.props;
    const { metadataFormState, metadataIds } = this.state;

    if (!form.file) {
      return this.setState({ showFileError: true });
    }

    if (!form.entity) {
      return this.setState({ showEntityDropdownError: true });
    }

    const { firstPeriodDate, numPeriods, secondPeriodDate } = form;
    if (!firstPeriodDate || (numPeriods === 2 && !secondPeriodDate)) {
      return this.setState({ showDateInputError: true });
    }

    this.setState({
      showFileError: false,
      showEntityDropdownError: false,
      showDateInputError: false
    });

    const formData = new FormData();

    const periods = filter(Boolean, [
      form.firstPeriodDate,
      form.secondPeriodDate
    ]) as Date[];

    let periodArray;

    if (
      this.props.dateFormat &&
      this.props.dateFormat.toLowerCase() === "dd/mm/yyyy"
    ) {
      periodArray = periods.map((date: Date) => {
        const period = {} as Period;
        period.date = moment(date).format("DD/MM/YYYY");
        period.monthsCovered = 12;
        return period;
      });
    } else if (
      (this.props.dateFormat &&
        this.props.dateFormat.toLowerCase() === "mm/dd/yyyy") ||
      !this.props.dateFormat
    ) {
      periodArray = periods.map((date: Date) => {
        const period = {} as Period;
        period.date = moment(date).format("MM/DD/YYYY");
        period.monthsCovered = 12;
        return period;
      });
    }

    formData.append("file", form.file);
    formData.append("entityName", toTitleCase(form.entity.value.name));
    if (form.entity.value.entityId != null) {
      formData.append("moodysEntityID", form.entity.value.entityId);
    }

    formData.append("periods", JSON.stringify(periodArray));
    formData.append("isPriority", form.priority.toString());
    // Seems the right approach is to read data from document.form rather metadataFormState.
    // We have initial data in document.form and monitor changes
    // but, maybe, there are lot of extra fields to filter and manual cases to handle.
    // So, maybe, it was more convenient to read data directly from local state.
    // Anyway, we have two source of truths (so extra codes and risks) which should be handled.

    Object.keys(metadataFormState).forEach(formKey => {
      const metadata = metadataFormState[formKey].value;
      if (!metadata) {
        return;
      }
      if (isMetaDataValueAModelTemplate(metadata)) {
        formData.append("template", metadata.modelTemplateType);
        if (metadata.modelTemplateVersion) {
          formData.append("templateVersion", metadata.modelTemplateVersion);
        }
      }
    });

    const metadataList: MetadataItemsContainingIds[] = [];

    if (this.props.metadataUploadFormConfig) {
      this.props.metadataUploadFormConfig.forEach(metadataElement => {
        const name = metadataElement.formKey;
        const value = metadataFormState[name].value;
        const singleId = metadataIds.filter(item => item.fieldName === name);
        const id = singleId.length > 0 ? singleId[0].id : "";
        if (!value) {
          return;
        }

        if (name === "balanceSheetDateEndDate") {
          if (this.state.metadataFormState.valueForP2.value) {
            metadataList.push({
              name,
              value,
              id,
              valueForP2: this.state.metadataFormState.valueForP2.value
            });
          } else {
            metadataList.push({
              name,
              value,
              id
            });
          }
        }

        if (name !== "templateType" && name !== "balanceSheetDateEndDate") {
          metadataList.push({ name, value, id });
        }
      });
    }

    formData.append("metadataFields", JSON.stringify(metadataList));

    if (!metadataUploadFormConfig || metadataUploadFormConfig.length < 1) {
      return this.uploadFinancialDocument(formData);
    }

    const metaErrorArray = metadataUploadFormConfig.map(configField => {
      if (
        numPeriods === 2 &&
        !this.state.metadataFormState.valueForP2.value &&
        configField.formKey === "balanceSheetDateEndDate"
      ) {
        this.setMetadataFieldError(configField.formKey);
      }
      if (configField.isRequiredOnUpload && !form[configField.formKey]) {
        return this.setMetadataFieldError(configField.formKey);
      }
    });

    const metaErrorArrayMaxLength = metadataUploadFormConfig.map(
      configField => {
        const max = configField.maxValue;

        if (
          configField.inputType === "text" &&
          configField.isNumericType &&
          this.state.metadataFormState[configField.formKey].value &&
          max &&
          Number(this.state.metadataFormState[configField.formKey].value) >
            Number(max)
        ) {
          return this.setMetadataFieldErrorMaxLength(configField.formKey);
        }
      }
    );

    const metaErrorArrayNegative = metadataUploadFormConfig.map(configField => {
      const max = configField.maxValue;

      if (
        configField.formKey === "cocunut" &&
        configField.isNumericType &&
        this.state.metadataFormState[configField.formKey].value &&
        max &&
        Number(this.state.metadataFormState[configField.formKey].value) < 0
      ) {
        return this.setMetadataFieldErrorNegative(configField.formKey);
      }
    });

    if (metaErrorArray.filter(Boolean).length > 0) {
      return;
    }

    if (metaErrorArrayMaxLength.filter(Boolean).length > 0) {
      return;
    }

    if (metaErrorArrayNegative.filter(Boolean).length > 0) {
      return;
    }

    if (form.entity && form.entity.value.clientEntityID) {
      formData.append("clientEntityID", form.entity.value.clientEntityID);
      // This case added for BVD entities which don't have entityIDs, but clientEntityID
      // So clientEntityID will also serve as moodysEntityID.
      if (!form.entity.value.entityId) {
        formData.append("moodysEntityID", form.entity.value.clientEntityID);
      }
    }

    let continueUploading = true;
    metadataUploadFormConfig.map(configField => {
      if (configField.isRequiredOnUpload) {
        if (
          numPeriods === 2 &&
          configField.formKey === "balanceSheetDateEndDate" &&
          !this.state.metadataFormState.valueForP2.value
        ) {
          continueUploading = false;
        }

        if (
          !this.state.metadataFormState[configField.formKey].value ||
          (configField.isNumericType &&
            configField.maxValue &&
            Number(this.state.metadataFormState[configField.formKey].value) >
              Number(configField.maxValue)) ||
          (configField.formKey === "cocunut" &&
            Number(this.state.metadataFormState[configField.formKey].value) < 0)
        ) {
          continueUploading = false;
        }
      }
    });

    return continueUploading && this.uploadFinancialDocument(formData);
  };

  public uploadFinancialDocument = (formData: FormData) => {
    if (this.state.commentsPeriod1.length > 0) {
      this.appendComment2FormPeriod(formData, 0);
    }
    if (this.state.commentsPeriod2.length > 0) {
      this.appendComment2FormPeriod(formData, 1);
    }
    return this.props.uploadFinancialDocument({ formData });
  };

  public arePeriodDatesSame = () => {
    const { form } = this.props;

    const date1 = form.firstPeriodDate && form.firstPeriodDate.getTime();
    const date2 = form.secondPeriodDate && form.secondPeriodDate.getTime();
    return date1 === date2;
  };

  public renderMessage = () => {
    if (this.props.requestStatus === STATES.ERROR) {
      const errorMessage =
        "Both periods cannot have the same period date. Please set different dates for each period.";
      return (
        <div className="DocumentUploadForm__message">
          {this.arePeriodDatesSame()
            ? errorMessage
            : this.props.errorMessage
            ? this.props.errorMessage
            : "Something went wrong"}
        </div>
      );
    }
    return null;
  };

  public render() {
    const { form } = this.props;

    return (
      <MuiThemeProvider theme={materialTheme}>
        <div>
          <h1 className="DocumentUploadForm__header">Upload a Statement</h1>
          {this.renderMessage()}
          <form onSubmit={this.handleSubmit} noValidate={true}>
            <div className="form__group form__file-container">
              <input
                required={true}
                key={this.state.fileInputKey}
                type="file"
                name="file"
                id="file"
                accept=".xls,.xlsx,.pdf, application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                onChange={this.handleFileChange}
              />
              <label
                className={
                  this.state.isDragAndDropActive
                    ? "form__file-label form__file-label--active"
                    : this.state.showFileError
                    ? "form__file-label form__file-label--error"
                    : "form__file-label"
                }
                htmlFor="file"
                onDrop={this.onFileDrop}
                onDragOver={this.onFileDragOver}
                onDragLeave={this.onFileDragEnd}
              >
                {this.props.form.file
                  ? this.props.form.file.name
                  : "Choose file"}
              </label>
            </div>

            <div className="DocumentUploadForm__entity-header">
              <div className="DocumentUploadForm__entity__title">Entity</div>
              <div
                className="DocumentUploadForm__entity__createEntity"
                onClick={this.props.toggleCreateEntityModal}
              >
                Create an entity
              </div>
            </div>

            <AsyncSelect
              cacheOptions={true}
              defaultOptions={this.state.entitySearchResults}
              loadOptions={this.fetchNewEntities}
              placeholder="Type to search for an entity..."
              className={
                !form.entity && this.state.showEntityDropdownError
                  ? "DocumentUploadForm__entity-dropdown DocumentUploadForm__entity-dropdown--error"
                  : "DocumentUploadForm__entity-dropdown"
              }
              onChange={this.handleEntityChange as any} // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/32553
              classNamePrefix="DocumentUploadForm__entity"
              value={form.entity}
              inputValue={form.entity ? undefined : this.state.entityInputValue}
              components={{ Option: EntityOption }}
              onInputChange={this.handleEntityInputChange}
              onKeyDown={this.handleEntityKeyDown}
            />

            {!form.entity && this.state.showEntityDropdownError && (
              <div className="DocumentUploadForm__error-msg form__helper-text">
                Please select an entity
              </div>
            )}

            <div className="DocumentUploadForm__period__title">Period</div>
            <FormControl required={true}>
              <RadioGroup
                name="numPeriods"
                row={true}
                onChange={this.handleChangePeriod}
                value={String(form.numPeriods)}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="One Period"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label="Two Periods"
                />
              </RadioGroup>
            </FormControl>
            <div className="form__group DocumentUploadForm__period-date-container">
              <div className="DocumentUploadForm__period-date">
                <DateInput
                  name="firstPeriodDate"
                  label="Period End Date"
                  value={form.firstPeriodDate}
                  onChange={this.props.onUploadFormChange}
                  showDateInputError={this.state.showDateInputError}
                  placeholder={
                    this.props.dateFormat
                      ? this.props.dateFormat.toLowerCase()
                      : "mm/dd/yyyy"
                  }
                  format={
                    this.props.dateFormat &&
                    this.props.dateFormat.toLowerCase() === "dd/mm/yyyy"
                      ? "DD/MM/YYYY"
                      : "MM/DD/YYYY"
                  }
                />

                <small
                  className={
                    form.numPeriods === 2
                      ? "form__helper-text-periods"
                      : "form__helper-text-periods form__helper-text-one-period"
                  }
                >
                  End date of most recent period.
                </small>
                <div
                  className="DocumentUploadForm__add-comment"
                  onClick={this.openCommentPopoverPeriod1}
                >
                  <CommentPopover
                    comments={this.state.commentsPeriod1}
                    shouldHideInput={
                      this.state.commentsPeriod1 &&
                      this.state.commentsPeriod1.length > 0
                    }
                    isOpen={Boolean(this.state.commentPopoverAnchorElPeriod1)}
                    onClose={this.closeCommentPopover}
                    anchorEl={this.state.commentPopoverAnchorElPeriod1}
                    updateComments={this.updateCommentsForPeriod1}
                    dontPostToBackend={true}
                    canEditComments={true}
                    canDeleteComments={true}
                    period={periodFromFormDate(form.firstPeriodDate)}
                    hasFocus={true}
                  />
                  <IconButton
                    className={
                      this.state.commentsPeriod1 &&
                      this.state.commentsPeriod1.length > 0
                        ? "DocumentUploadForm__comment__icon"
                        : "DocumentUploadForm__add-comment__icon"
                    }
                    onClick={this.openCommentPopoverPeriod1}
                    children={
                      this.state.commentsPeriod1 &&
                      this.state.commentsPeriod1.length > 0 ? (
                        <CommentIcon />
                      ) : (
                        <AddCommentIcon />
                      )
                    }
                  />
                  {this.state.commentsPeriod1 &&
                    this.state.commentsPeriod1.length === 0 && (
                      <span className="DocumentUploadForm__add-comment__text">
                        Add Comment
                      </span>
                    )}
                </div>
              </div>
              {form.numPeriods === 2 ? (
                <div className="DocumentUploadForm__period-date DocumentUploadForm__period-date--second">
                  <DateInput
                    name="secondPeriodDate"
                    label="Period End Date"
                    value={form.secondPeriodDate}
                    onChange={this.props.onUploadFormChange}
                    showDateInputError={this.state.showDateInputError}
                    placeholder={
                      this.props.dateFormat
                        ? this.props.dateFormat.toLowerCase()
                        : "mm/dd/yyyy"
                    }
                    format={
                      this.props.dateFormat &&
                      this.props.dateFormat.toLowerCase() === "dd/mm/yyyy"
                        ? "DD/MM/YYYY"
                        : "MM/DD/YYYY"
                    }
                  />
                  <small className="form__helper-text-periods">
                    End date of prior period.
                  </small>
                  <div
                    className="DocumentUploadForm__add-comment"
                    onClick={this.openCommentPopoverPeriod2}
                  >
                    <CommentPopover
                      comments={this.state.commentsPeriod2}
                      shouldHideInput={
                        this.state.commentsPeriod2 &&
                        this.state.commentsPeriod2.length > 0
                      }
                      isOpen={Boolean(this.state.commentPopoverAnchorElPeriod2)}
                      onClose={this.closeCommentPopover}
                      anchorEl={this.state.commentPopoverAnchorElPeriod2}
                      updateComments={this.updateCommentsForPeriod2}
                      dontPostToBackend={true}
                      canEditComments={true}
                      canDeleteComments={true}
                      period={periodFromFormDate(form.secondPeriodDate)}
                      hasFocus={true}
                    />
                    <IconButton
                      className={
                        this.state.commentsPeriod2 &&
                        this.state.commentsPeriod2.length > 0
                          ? "DocumentUploadForm__comment__icon"
                          : "DocumentUploadForm__add-comment__icon"
                      }
                      onClick={this.openCommentPopoverPeriod2}
                      children={
                        this.state.commentsPeriod2 &&
                        this.state.commentsPeriod2.length > 0 ? (
                          <CommentIcon />
                        ) : (
                          <AddCommentIcon />
                        )
                      }
                    />
                    {this.state.commentsPeriod2 &&
                      this.state.commentsPeriod2.length === 0 && (
                        <span className="DocumentUploadForm__add-comment__text">
                          Add Comment
                        </span>
                      )}
                  </div>
                </div>
              ) : null}
            </div>
            {this.renderMetadataFields()}
            <div className="form__group DocumentUploadForm__priority-comment-container">
              <div className="DocumentUploadForm__priority-container">
                <Checkbox
                  id="priority"
                  name="priority"
                  color="primary"
                  checked={form.priority}
                  onChange={this.handlePriorityChange}
                  className={"DocumentUploadForm DocumentUploadForm__priority"}
                />
                <label
                  className="DocumentUploadForm__priority-label"
                  htmlFor="priority"
                >
                  Mark as high priority
                </label>
              </div>
            </div>
            <div className="DocumentUploadForm__actions">
              <QuiqButton
                type="submit"
                color="blue"
                isLoading={this.props.requestStatus === STATES.LOADING}
              >
                Upload
              </QuiqButton>

              {this.props.requestStatus !== STATES.LOADING && (
                <QuiqButton
                  className="DocumentUploadForm__actions__cancel"
                  variant="text"
                  onClick={this.props.closeModal}
                >
                  Cancel
                </QuiqButton>
              )}
            </div>
          </form>
        </div>
      </MuiThemeProvider>
    );
  }

  private renderMetadataFields = () => {
    if (!this.props.metadataUploadFormConfig) {
      return null;
    }

    return map(formFieldData => {
      return (
        <div className="form__group__wrapper">
          <div key={formFieldData.formKey} className="form__group">
            <div className="DocumentUploadForm__section__title">
              {formFieldData.label}
            </div>
            {formFieldData.inputType === "select" && (
              <Select
                className={
                  this.state.metadataFormState[formFieldData.formKey]
                    .shouldShowError
                    ? "DocumentUploadForm__metadata__input--error"
                    : ""
                }
                options={formFieldData.options}
                placeholder={`Select ${formFieldData.label}`}
                required={formFieldData.isRequiredOnUpload}
                onChange={
                  this.handleMetadataInputChange(formFieldData.formKey) as any
                }
                classNamePrefix={`DocumentUploadForm__${formFieldData.formKey} DocumentUploadForm__metadata__input`}
                defaultValue={formFieldData.defaultValue}
              />
            )}
            <div className="form__group DocumentUploadForm__period-date-container">
              {formFieldData.inputType === "text" && (
                <div className="DocumentUploadForm__period-date">
                  <TextInput
                    isNumeric={formFieldData.isNumericType}
                    isDate={formFieldData.isDateType}
                    onChange={this.handleMetadataTextInputChange(
                      formFieldData.formKey
                    )}
                    value={
                      this.state.metadataFormState[formFieldData.formKey].value
                    }
                    placeholder={formFieldData.label}
                    maxLength={
                      formFieldData.maxLength ? formFieldData.maxLength : 255
                    }
                  />
                </div>
              )}

              {this.props.form.numPeriods === 2 &&
                formFieldData.formKey === "balanceSheetDateEndDate" && (
                  <div className="DocumentUploadForm__period-date DocumentUploadForm__period-date--second">
                    <TextInput
                      isNumeric={formFieldData.isNumericType}
                      isDate={formFieldData.isDateType}
                      onChange={this.handleMetadataTextInputChange(
                        "valueForP2"
                      )}
                      value={this.state.metadataFormState.valueForP2.value}
                      placeholder={formFieldData.label}
                    />
                  </div>
                )}
            </div>
            {this.state.metadataFormState[formFieldData.formKey]
              .shouldShowError && (
              <div className="DocumentUploadForm__error-msg form__helper-text">
                {formFieldData.label} is required
              </div>
            )}
            {this.state.metadataFormState[formFieldData.formKey]
              .shouldShowErrorMaxLength && (
              <div className="DocumentUploadForm__error-msg form__helper-text">
                {formFieldData.label} value can not transcend{" "}
                {formFieldData.maxValue}
              </div>
            )}
            {this.state.metadataFormState[formFieldData.formKey]
              .shouldShowErrorNegative && (
              <div className="DocumentUploadForm__error-msg form__helper-text">
                {formFieldData.label} value can not be negative
              </div>
            )}
          </div>
          {Boolean(formFieldData.displayMetadataId) && (
            <TextField
              label={`id`}
              className="DocumentUploadForm__metadata__id"
              id="outlined-size-small"
              onChange={
                this.handleMetadataIdsChange(formFieldData.formKey) as any
              }
            />
          )}
        </div>
      );
    }, this.props.metadataUploadFormConfig);
  };

  private handleMetadataInputChange = (formKey: string) => (
    option: MetadataInputOption
  ) => {
    if (!this.props.metadataUploadFormConfig) {
      return;
    }

    this.props.onUploadFormChange({ [formKey]: option.value });
    this.setState({
      metadataFormState: {
        ...this.state.metadataFormState,
        [formKey]: { value: option.value, shouldShowError: false }
      }
    });
  };

  private handleMetadataTextInputChange = (formKey: string) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!this.props.metadataUploadFormConfig) {
      return;
    }
    const value = event.target.value;
    this.props.onUploadFormChange({ [formKey]: value });
    this.setState({
      metadataFormState: {
        ...this.state.metadataFormState,
        [formKey]: { value, shouldShowError: false }
      }
    });
  };

  private handleMetadataIdsChange = (formKey: string) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!this.props.metadataUploadFormConfig) {
      return;
    }

    const value = event.target.value;

    const metadataIdList = this.state.metadataIds.map(
      metadataItem => metadataItem.fieldName
    );

    const index = metadataIdList.indexOf(formKey);
    if (index === -1) {
      this.setState({
        metadataIds: [
          ...this.state.metadataIds,
          { fieldName: formKey, id: value }
        ]
      });
    } else {
      const newMetadataIdsArr = [...this.state.metadataIds];
      newMetadataIdsArr[index] = { fieldName: formKey, id: value };

      this.setState({ metadataIds: newMetadataIdsArr });
    }
  };

  private initMetadataFormState = () => {
    const { metadataUploadFormConfig } = this.props;
    if (!metadataUploadFormConfig) {
      return;
    }

    let metadataFormState: MetadataFormState = metadataUploadFormConfig.reduce(
      (state, configField) => {
        state[configField.formKey] = {
          value: configField.defaultValue
            ? configField.defaultValue.value
            : null,
          shouldShowError: false
        };
        return state;
      },
      {}
    );

    metadataFormState = {
      ...metadataFormState,
      valueForP2: { value: null, shouldShowError: false }
    };

    this.setState({ metadataFormState });
  };

  private setMetadataFieldError = (formKey: string) => {
    const oldMetadataFormState = { ...this.state.metadataFormState };
    const oldMetadataFormField = oldMetadataFormState[formKey];
    const newMetadataFormState: MetadataFormState = {
      ...oldMetadataFormState,
      [formKey]: { ...oldMetadataFormField, shouldShowError: true }
    };
    return this.setState({ metadataFormState: newMetadataFormState });
  };

  private setMetadataFieldErrorMaxLength = (formKey: string) => {
    const oldMetadataFormState = { ...this.state.metadataFormState };
    const oldMetadataFormField = oldMetadataFormState[formKey];
    const newMetadataFormState: MetadataFormState = {
      ...oldMetadataFormState,
      [formKey]: { ...oldMetadataFormField, shouldShowErrorMaxLength: true }
    };
    return this.setState({ metadataFormState: newMetadataFormState });
  };

  private setMetadataFieldErrorNegative = (formKey: string) => {
    const oldMetadataFormState = { ...this.state.metadataFormState };
    const oldMetadataFormField = oldMetadataFormState[formKey];
    const newMetadataFormState: MetadataFormState = {
      ...oldMetadataFormState,
      [formKey]: { ...oldMetadataFormField, shouldShowErrorNegative: true }
    };
    return this.setState({ metadataFormState: newMetadataFormState });
  };

  private updateCommentsForPeriod1 = (comments: Comment[]) => {
    this.setState({ commentsPeriod1: comments });
  };

  private updateCommentsForPeriod2 = (comments: Comment[]) => {
    this.setState({ commentsPeriod2: comments });
  };

  private openCommentPopoverPeriod1 = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    this.setState({
      commentPopoverAnchorElPeriod1: event.currentTarget
    });
  };

  private openCommentPopoverPeriod2 = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    this.setState({
      commentPopoverAnchorElPeriod2: event.currentTarget
    });
  };

  private closeCommentPopover = () => {
    this.setState({
      commentPopoverAnchorElPeriod1: null,
      commentPopoverAnchorElPeriod2: null
    });
  };

  private fetchNewEntities = (value: string, callback: any) => {
    return new Promise(() => {
      api.entities.search(value).then(response => {
        const options = transformSearchEntityResults(response);
        this.setState({ entitySearchResults: options });
        callback(options);
      });
    });
  };

  private onFileDrop = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault();

    if (e.dataTransfer.items.length <= 0) {
      return;
    }

    if (e.dataTransfer.items[0].kind !== "file") {
      return;
    }

    const file = e.dataTransfer.items[0].getAsFile();

    if (file === null) {
      return;
    }

    if (!this.isValidFile(file)) {
      this.setState({ isDragAndDropActive: false });
      return;
    }

    this.props.onUploadFormChange({ file });
    this.setState({ isDragAndDropActive: false });
  };

  private isValidFile = (file: File) => {
    return (
      file.type === ".xls" ||
      file.type === ".xlsx" ||
      file.type === "application/pdf" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel" ||
      file.type === ".doc" ||
      file.type === ".docx" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      file.type === "application/msword"
    );
  };

  private onFileDragOver = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    if (!this.state.isDragAndDropActive) {
      this.setState({ isDragAndDropActive: true });
    }
  };

  private onFileDragEnd = (e: React.DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    if (this.state.isDragAndDropActive) {
      this.setState({ isDragAndDropActive: false });
    }
  };

  private appendComment2FormPeriod = (formData: FormData, idx: number) => {
    const periodsString = formData.get("periods") as string;
    const periods = periodsString ? JSON.parse(periodsString) : null;
    if (periods && periods[idx]) {
      periods[idx].comment = this.state["commentsPeriod" + (idx + 1)][0].body;
      formData.set("periods", JSON.stringify(periods));
    }
  };
}

const EntityOption = (props: OptionProps<EntityDropdownOption>) => {
  const {
    className,
    cx,
    getStyles,
    isDisabled,
    isFocused,
    isSelected,
    innerRef,
    innerProps,
    data
  } = props;
  return (
    <div
      ref={innerRef}
      className={
        cx(
          css(getStyles("option", props)),
          {
            option: true,
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
          },
          className
        ) || undefined
      }
      {...innerProps}
    >
      <b>{formatEntityValue(data.value.name)}</b> -{" "}
      <i>
        {join(
          ", ",
          filter(value => value.length !== 0, [
            formatEntityValue(data.value.city),
            formatEntityValue(data.value.country)
          ])
        )}
      </i>
    </div>
  );
};

const mapStateToProps = (state: State) => ({
  form: state.documentUpload.form,
  requestStatus: state.documentUpload.request.status,
  errorMessage: state.documentUpload.request.message,
  userId: getUserId(state),
  metadataUploadFormConfig: getMetadataUploadFormConfig(state),
  dateFormat: dateFormat(state)
});

const periodFromFormDate = (date: Date | null) => {
  return date ? moment(date).format("YYYYMMDD") : undefined;
};

export default connect(
  mapStateToProps,
  {
    reloadBriefSpreads: reloadBriefSpreads.action,
    uploadFinancialDocument: uploadFinancialDocument.action,
    addComment: addComment.action,
    onUploadFormChange
  }
)(DocumentUploadForm);



// WEBPACK FOOTER //
// ./src/documentUpload/components/DocumentUploadForm.tsx